import useAuth from './use-auth';

export const useBrevoEmailEnabled = () => {
  const { user } = useAuth();
  return user?.website?.flags?.brevo_email === 'enabled';
};
